import Api from './api'
import Utils from '../../utils/utils'
import Storage from '../storage/storage'
import Template from '../../interaction/template'
import Manifest from '../manifest'
import Controller from '../controller'
import Noty from '../../interaction/noty'
import Lang from '../lang'
import Modal from '../../interaction/modal'
import Settings from '../../interaction/settings/settings'
import Reguest from '../../utils/reguest'
import Platform from '../platform'

let poll_timer = null

function init(){
    Settings.listener.follow('open',(e)=>{
        if(e.name == 'account') e.body.find('.settings--account-device-add').on('hover:enter', ()=>{
            login(()=>{
                Controller.toggle('settings_component')
            })
        })
    })
}

function stopPolling(){
    if(poll_timer){
        clearInterval(poll_timer)
        poll_timer = null
    }
}

function login(callback){
    let html = Template.get('account_add_device_new')
    let network = new Reguest()

    stopPolling()

    if(Platform.tv()){
        html.addClass('layer--' + (Platform.mouse() ? 'wheight' : 'height'))
    }
    else{
        html.addClass('account-modal-split--mobile')
    }

    let bot_link = html.find('.account-modal-split__bot-link')
    let code_el  = html.find('.account-modal-split__device-code')
    let status   = html.find('.account-modal-split__status')

    code_el.text('...')
    status.text('')

    Modal.open({
        title: '',
        html: html,
        size: Platform.tv() ? 'full' : 'medium',
        scroll: {
            nopadding: true
        },
        onBack: ()=>{
            stopPolling()
            network.clear()

            Modal.close()

            callback && callback()
        }
    })

    // Request code from backend (платформа/бренд — чтобы код привязался к нужному боту)
    let codeUrl = Api.url() + 'device/code' + (Manifest.platform ? '?platform=' + encodeURIComponent(Manifest.platform) : '')

    network.silent(codeUrl, (result)=>{
        let code      = result.code
        let sessionId = result.session_id
        let botUser   = result.bot_username || Manifest.bot_username

        code_el.text(code)

        if(botUser){
            bot_link.text('@' + botUser).attr('href', 'https://t.me/' + botUser)

            let qr_code = html.find('.account-modal-split__qr-code')
            let img     = html.find('.account-modal-split__qr-img')

            Utils.qrcode('https://t.me/' + botUser, qr_code, ()=>{
                qr_code.remove()
                img.removeClass('hide').addClass('loaded')
            })
        }

        status.text(Lang.translate('account_device_waiting'))

        // Poll for authorization
        poll_timer = setInterval(()=>{
            let check = new Reguest()

            check.silent(Api.url() + 'device/check/' + sessionId, (data)=>{
                if(data.status === 'ok'){
                    stopPolling()

                    Storage.set('account', {
                        token: data.token,
                        email: data.profile.username || data.profile.telegramId || '',
                        profile: {
                            id: data.profile.id,
                            name: data.profile.firstName || data.profile.username || 'Main',
                            icon: 'l_1',
                            main: true,
                            child: false,
                            age: 0
                        }
                    }, true)

                    Storage.set('account_email', data.profile.username || '', true)

                    // premium = timestamp окончания подписки; нет активной подписки → 0 (Free)
                    let sub = data.profile.subscription
                    let isPaid = !!sub

                    Storage.set('account_user', JSON.stringify({
                        id: data.profile.id,
                        premium: isPaid ? new Date(sub.expiresAt).getTime() : 0
                    }), true)

                    // Автовключение синхронизации — закладки/таймкоды сразу начнут синкаться
                    Storage.set('account_use', true, true)

                    Modal.close()

                    window.location.reload()
                }
                else if(data.status === 'expired'){
                    stopPolling()

                    status.text(Lang.translate('account_device_code_expired'))

                    Noty.show(Lang.translate('account_device_code_expired'))
                }
            }, ()=>{
                // network error during poll — ignore, keep polling
            })
        }, result.poll_interval ? result.poll_interval * 1000 : 3000)

    }, (e)=>{
        code_el.text('—')
        status.text(Lang.translate('network_noconnect'))

        Noty.show(Lang.translate('network_noconnect'))
    })
}

export default {
    init: Utils.onceInit(init),
    login
}